<div class="progress-wrapper">
    <ridango-page-content-wrapper>
        <ridango-progress-v2 [steps]="steps" [activeStep]="activeStep"></ridango-progress-v2>
    </ridango-page-content-wrapper>
</div>

<div class="block--content block" id="main-content">
    <ridango-page-content-wrapper>
        <rwidget-alert></rwidget-alert>
    </ridango-page-content-wrapper>

    <ridango-page-content-wrapper>
        <div class="ticket">
            <div class="intro-text" *ngIf="(docNums$ | async)?.length > 0">
                <h1 class="title">{{ 'PURCHASE_RESULT_TITLE_YOUR_TICKET' | translate }}</h1>
                <p>
                    <span>{{ 'PURCHASE_RESULT_PAGE_DESCRIPTION' | translate }}</span>
                </p>
            </div>

            <rwidget-payment-result></rwidget-payment-result>
        </div>
    </ridango-page-content-wrapper>

    <ridango-page-content-wrapper>
        <rwidget-purchase-invoice
            *ngIf="
                (docNums$ | async)?.length > 0 &&
                resultCode !== (adyenResultStatusEnum.RECEIVED || adyenResultStatusEnum.PENDING)
            "
            [token]="(cart$ | async)?.jwt_token"
            [locale]="selectedLanguageCode"
            (scrollUp)="scrollToTop()">
        </rwidget-purchase-invoice>
    </ridango-page-content-wrapper>
</div>
